import { chatApi } from "../../services/chatApi";
import { nebulaChatApi } from "../../services/nebulaChat";
import { AppThunk, RootState } from "../../store";
import { selectIsNebulaChat } from "../appSlice";
import { selectNebulaChats } from "../chatNSlice";
import { selectChatList, selectThreadsList } from "../multiSelectors/selectors";
import { selectCurrentUserId } from "../userSlice";

export const markAllChatsRead =
    (): AppThunk =>
        (dispatch, getState) => {
            const state: RootState = getState();


            const userUuid = selectCurrentUserId(state);
            const isNebulaChat = selectIsNebulaChat(state);

            if (isNebulaChat) {
                const chats = selectNebulaChats(state);

                chats.forEach(c => {
                    if (c.unread > 0 && !c.is_muted) {
                        dispatch(nebulaChatApi.endpoints.readAllMessagesN.initiate({
                            uuid: c.uuid,
                            type: c.type as any,
                        }));
                    }
                });
            } else {
                const chats = selectChatList(state).filter(c => c.unread_count > 0);
                const threads = selectThreadsList(state).filter(t => t.unread_count > 0);

                chats.concat(threads).forEach(c => {
                    dispatch(chatApi.endpoints.postAllMessagesRead.initiate({
                        voip_user_uuid: userUuid,
                        type: c.type,
                        chat_uuid: c.uuid,
                    }));
                });
            }
        };
